// extracted by mini-css-extract-plugin
module.exports = {"content":"src-pages-guide-component-TaxAuthProtocol-protocol-InstallProtocol-__index__content--19Zrr"};